import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './IntraOne.frontend.types'

@Injectable({ providedIn: 'root' })
export class IntraOne_pallet_activation_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { shipping_container_id: number }): Promise<{ reason?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipping_container_id)) {
      $missingRequiredInParams.push('\'shipping_container_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/IntraOne/functions/pallet_activation_flow`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

